import http from './http'

const base = '/jetlinks/visualization/resources/images'
export const getImageCatalogs = options => http.get(base + '/catalogs', options)
export const queryImages = (query, options) => http.post(base + '/_query', query, options)
export const createImage = request => http.post(base + (request.visibility === 'public' ? '/_publish' : '/_add'), request)
export const getImage = (id, options) => http.get(base + '/' + encodeURIComponent(id), options)
export const updateImage = (id, request) => http.post(base + '/' + encodeURIComponent(id) + (request.visibility === 'public' ? '/_publish' : '/_update'), request)
export const getPreviousImage = (id, options) => http.get(base + '/' + encodeURIComponent(id) + '/previous', options)
export const restoreImage = (id, request) => http.post(base + '/' + encodeURIComponent(id) + '/_restore', request)
export const archiveImage = (id, request) => http.post(base + '/' + encodeURIComponent(id) + '/_archive', request)
export const createImageCatalog = request => http.post(base + '/catalogs/_add', request)

// 复用平台文件上传接口，返回真实文件ID；资源业务登记由 createImage 完成。
export function uploadImageFile (file, options = {}) {
  const form = new FormData()
  form.append('file', file)
  return http.post('/jetlinks/file/upload?options=publicAccess', form, options)
}
